<template>
  <div>
    <v-skeleton-loader
      v-if="currentShop === null"
      loading
      transition="fade-transition"
      type="article"
    ></v-skeleton-loader>
<!--     <div v-if="currentShop">
      {{currentShop.shopimage}}
    </div> -->

     <v-card
      width="100%"
      min-height="100vh"
      tile
      flat
      class="black--text text-center"
      v-if="currentShop"
      ref="currentShop"
    >
      <v-row justify="center" class="ma-0">
        <v-col cols="12" class="pa-0">

          <div class="images-logoNshop">
            <v-skeleton-loader
              :loading="currentShop === null"
              transition="fade-transition"
              type="card"
            >
              <v-img
                :src="`http://api.trcgagarinsky.ru/terminal__tmp/`+currentShop.shopimage[0]"
                aspect-ratio="3.2"
                v-if=" currentShop.shopimage.length>0"
                
              ></v-img>
            </v-skeleton-loader>
          </div>
        </v-col>
      </v-row>
      <v-row class="ma-0 shop-info">
        <v-col cols="10" sm="2" md="2" lg="2" xl="2">

        </v-col>

        <v-col cols="12" sm="12" md="12" lg="10" xl="10">
          <v-row justify="start" class="ma-0 pa-0">
            <v-col cols="12" class="pa-0">
              <v-card tile :elevation="2" height="120" width="120" class="logo-shop-card">
                <div
                  class="mx-0 pa-4 logo-shop-img"
                  :style=" `background-image: url(http://api.trcgagarinsky.ru/terminal__tmp/`+currentShop.logourl+`)`"
                ></div>
              </v-card>
              <p class="body-1 text-left mt-4" v-html="currentShop.nameK"></p>

              <v-row justify="start" class="ma-0">
                <v-col cols="6" sm="4" md="6" lg="4" xl="4" class="py-0">
                  <v-row justify="start">
                    <v-col cols="12" sm="10" md="8" lg="8" xl="8" class="pa-0 nmm">
                      <div class="subtitle-1 text-left">
                        <v-icon color="black" class="pr-3">mdi-layers-triple</v-icon>
                        {{currentShop.floor}} этаж
                      </div>
                      <div class="text-left">
                        <span
                          @click="viewOnMap(currentShop.id)"
                          v-if="currentShop.idmapshop.length === 4"
                        >
                          <v-icon class="pr-2" color="black" left>mdi-map</v-icon>
                          <span class="cursor-url hover-underline">Показать на схеме</span>
                        </span>

                        <div class="subtitle-1" v-if="currentShop.phone!==''">
                          <v-icon color="black" class="pr-3">mdi-phone</v-icon>
                          <Phone :number="currentShop.phone" />
                        </div>
                        <div class="subtitle-1" v-if="currentShop.timework!==''">
                          <v-icon color="black " class="pr-3">mdi-clock</v-icon>
                          <span v-if="$vuetify.breakpoint.smAndUp" >Время работы:</span>  {{currentShop.timework}}
                        </div>
                        <div class="subtitle-1" v-if="currentShop.actions.length > 0">
                          <v-icon color="black" class="pr-3">mdi-sale</v-icon>
                          {{news.find(nsh=>nsh.id==currentShop.actions[0]).titleAction}}
                        </div>
                      </div>


                    </v-col>
                    <v-col cols="8"></v-col>
                  </v-row>

                </v-col>


                <v-col cols="6" sm="6" md="6" lg="4" xl="4" class="py-0">
                  <div class="subtitle-1 text-left text-catg " v-if="subCategories.length > 0">
                    <div  :key="'fff-'+ic"  id="hrefCat" v-for="(sCat, ic) in  subCategories">
                      
                      <!-- <span @click="goToSubcategory(sCat)">{{sCat.namesubcat}}</span> -->
                      <router-link class="phone-link" :to="{ path: nameRoutPath(sCat)}">{{sCat.namesubcat}}</router-link>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row justify="center" class="ma-0">
        <v-col cols="12" sm="10" md="10" lg="8" class="text-left pa-sm-0  pa-xs-1">
          <div v-html="currentShop.shoptext" class="shop-description"></div>
        </v-col>
      </v-row>
      <SeoBlock
        :seotxt1="currentShop.seo_text_1"
        :seotxt2="currentShop.seo_text_2"
        :seogallery="currentShop.seo_images"
      />
    </v-card> 

    <SelectMapDialog
      :selectIDShop="selectIDShop"
      :getImgFloor="getImgFloor"
      v-if="currentShop !== null"
    />
  </div>
</template>
<script>
import Vue from "vue";
import Vuex from "vuex";
import router from "vue-router";
import axios from "axios";
import Phone from "@/components/Phone";
import Email from "@/components/Email";
import SeoBlock from "@/components/SeoBlock";
import SelectMapDialog from "@/components/SelectMapDialog";
Vue.use(Vuex);
export default {
  inject: ["theme"],
  name: "SingleShop",
  components: {
    Phone,
    Email,
    SeoBlock,
    SelectMapDialog,
    VBoilerplate: {
      functional: true,
      render(h, { data, props, children }) {
        return h(
          "v-skeleton-loader",
          {
            ...data,
            props: {
              boilerplate: true,
              elevation: 2,
              ...props,
            },
          },
          children
        );
      },
    },
  },
  data() {
    return {
      nameShop: null,
      selectIDShop: null,      
      imgF1: require("@/assets/1_floor.jpg"),
      imgF2: require("@/assets/2_floor.jpg"),
      imgF3: require("@/assets/3_floor.jpg"),
    };
  },
  metaInfo() {
    return {
      title: "Магазин - " + this.nameShop + " - ",
    };
  },

  computed: {
    isDebug:{
      get() {
        return this.$store.state.app.isDebug;
      },
    },
    isMobile: {
      get () {
        return this.$store.state.app.isMobile
      }
      
    },    
    subCategories() {
      const vApp = this
      if(DEBUG) console.log('pre length :>> ')
    //  if(DEBUG) console.log("vApp.$store.state.category :>> ", vApp.$store.state.category.categories.length)

  if(vApp.$store.state.category.categories.length >0) {      
      if(DEBUG) console.log("path1 :>> ", vApp.currBreadcrumb[1].text)
      let filterCatCurrShop =  []
      if(DEBUG) console.log('vApp.currBreadcrumb[1].text :>> ', vApp.currBreadcrumb[1].text)

          const allc = vApp.$store.state.category.categories
          const currShCat = vApp.currentShop.category
          if(DEBUG) console.log(' <<<<<<<<<<<<<<<<<<<<<<<< ===== : allc :>> ', allc);
          if(DEBUG) console.log(' <<<<<<<<<<<<<<<<<<<<<<<< ===== : currShCat :>> ', currShCat);
          for (let ic = 0; ic < currShCat.length; ic++) {
            const elic = currShCat[ic];
            if(DEBUG) console.log(' <<<<<<<<<<<<<<<<<<<<<<<< ===== : elic :>> ', elic);

            for (const keysc in allc) {
              if (Object.hasOwnProperty.call(allc, keysc)) {
                const elsc = allc[keysc]
                if(DEBUG) console.log('elsc :>> ', elsc)
                if(elsc.id === elic) {
                      filterCatCurrShop.push(  {
                          id:elsc.id,
                          namesubcat:elsc.name,
                          slug:elsc.slug
                        }
                      )

                }
                else{
                  const findSubcat = elsc.category.find(fscatel=>fscatel.id === elic)
                  if(DEBUG) console.log('findSubcat :>> ', findSubcat)
                  if(typeof findSubcat !== 'undefined'){
                    filterCatCurrShop.push(  {
                          id:findSubcat.id,
                          namesubcat:findSubcat.namesubcat,
                          slug:findSubcat.slug
                        }
                      )
                  }


                }

              }
            }            
            
          }

/*             for (const keysc in allc) {
              if (Object.hasOwnProperty.call(allc, keysc)) {
                const elsc = allc[keysc]
                let fasc = elsc.category.filter((csc) =>
                  csc.objects.find((ids) => ids.id === vApp.currentShop.id)
                )
                if (fasc.length){
                  if(DEBUG) console.log('fasc :>> ', fasc)
                  if(DEBUG) console.log('[...fasc] :>> ', ...fasc)
                    filterCatCurrShop.push(...fasc)
                }                
              }
            } */
            if(DEBUG) console.log('elsc ===>>> filterCatCurrShop :>> ', filterCatCurrShop)



/*       let numIDCat = 0
      switch (vApp.currBreadcrumb[1].text) {
        case "Магазины":
          numIDCat = 0
          const allc = vApp.$store.state.category.categories

            for (const keysc in allc) {
              if (Object.hasOwnProperty.call(allc, keysc)) {
                const elsc = allc[keysc]
                let fasc = elsc.category.filter((csc) =>
                  csc.objects.find((ids) => ids.id === vApp.currentShop.id)
                )
                if (fasc.length){

                  if(DEBUG) console.log('fasc :>> ', fasc)
                  if(DEBUG) console.log('[...fasc] :>> ', ...fasc)
                    filterCatCurrShop.push(...fasc)
                }
                
                
                
              }
            }

if(DEBUG) console.log('elsc ===>>> filterCatCurrShop :>> ', filterCatCurrShop)


          break
        case "Кафе и рестораны":
          numIDCat = 1
          filterCatCurrShop = [
            {
              namesubcat:'Кафе и Рестораны',
              slug:'restorany-i-kafe'
            }
          ]
          break
        case "Услуги":
          numIDCat = 3
          filterCatCurrShop = [
            {
              namesubcat:'Услуги',
              slug:'uslugi'
            }
          ]
          break
        case "Развлечения":
          numIDCat = 4
          filterCatCurrShop = [
            {
              namesubcat:'Развлечения',
              slug:'razvlecheniya'
            }
          ]
          break

        default:
          break
      } */


/*       if(DEBUG) console.log(
        "filterCatCurrShop :>> ",
        [...filterCatCurrShop.map((k) => k.namesubcat)].join()
      ) */

      if(DEBUG) console.log(
        "filterCatCurrShop :>> ",
        filterCatCurrShop
      )

      if(DEBUG) console.log(
        "filterCatCurrShop Spread :>> ",
        [...filterCatCurrShop]
      )



 
      //return  [...filterCatCurrShop.map((k) =>'<a href="/newgagarin/magaziny/category/'+ k.slug+'" class="lk">'+ k.namesubcat+'</a>')].join("<br/>")
      //return  [...filterCatCurrShop]
      return  filterCatCurrShop
}
else {



      return  ""
}
    },
    isViewFind: {
      get() {
        return this.$store.state.app.isViewFind;
      },
      set(val) {
        let vApp = this;
        vApp.$store.dispatch("setIsViewFind", val);
      },
    },     
    loadPathData: {
      get() {
        return this.$store.getters.getLoadPathData;
      },
    },
    news() {
      return this.$store.state.news.news;
    },
    shops() {
      return this.$store.state.shops.shops;
    },
    showDialogMap: {
      get() {
        if(DEBUG) console.log(
          "this.$store.state.app.showDialogMap :",
          this.$store.state.app.showDialogMap
        );
        return this.$store.state.app.showDialogMap;
      },
      set(val) {
        let vApp = this;
        vApp.$store.dispatch("setShowDialogMap", val);
      },
    },
    titleInner: {
      get() {
        if(DEBUG) console.log(
          "this.$store.state.app.titleInner :",
          this.$store.state.app.titleInner
        );
        return this.$store.state.app.titleInner;
      },
      set(val) {
        let vApp = this;
        vApp.$store.dispatch("setTitleInner", val);
      },
    },
    currBreadcrumb: {
      get() {
        return this.$store.state.breadcrumb.currBreadcrumb;
      },
      set(val) {
        let vApp = this;
        vApp.$store.dispatch("setBreadcrumb", val);
      },
    },
    shopCategories: {
      get() {
        return this.$store.state.category.categories
      },
    },
    currentShop: {
      get() {
        return this.$store.state.shops.currentShop;
      },
      set(val) {
        let vApp = this;
        vApp.$store.dispatch("setCurrentShop", val);
      },
    },
    getImgFloor() {
      let vApp = this;
      if(DEBUG) console.log("vApp.currentShop :", vApp.currentShop);
      let selectShopFloor = vApp.currentShop.floor;
      switch (selectShopFloor) {
        case "1":
          return vApp.imgF1;
          break;
        case "2":
          return vApp.imgF2;
          break;
        case "3":
          return vApp.imgF3;
          break;

        default:
          break;
      }
    },
  },

  methods: {

    nameRoutPath(currCat){
      const vApp=this
      const nameRoutePath = vApp.$route.path.split('/')[1]
      let fullPathCat = ''

      //const findCurrCat = vApp.shopCategories.find(fscat=>fscat.)


      for (const kallc in vApp.shopCategories) {
        if (Object.hasOwnProperty.call(vApp.shopCategories, kallc)) {
          const elCC = vApp.shopCategories[kallc]
          
          if(elCC.id === currCat.id){
              if(DEBUG) console.log('elsubCC :>> ', elCC.slug)
              fullPathCat = '/'+elCC.slug
          }
          else{
              if(DEBUG) console.log('    Будем искать в подкатегориях')
              for (const key3 in elCC.category) {
                if (Object.hasOwnProperty.call(elCC.category, key3)) {
                    const elsubCC = elCC.category[key3]
                    if(elsubCC.id === currCat.id){
                      if(DEBUG) console.log('elsubCC :>> ', elsubCC.slug)
                      fullPathCat = '/'+elCC.slug+'/category/'+elsubCC.slug
                    }

                  
                }
              }

          }
          
        }
      }

      if(DEBUG) console.log('currCat :>> ', currCat)
      if(DEBUG) console.log("vApp.$route :", vApp.$route)
      
      switch (nameRoutePath) {
        case 0:
          
          break;
      
        default:
          break;
      }
      return fullPathCat
    },

    viewOnMap(idShop) {
      let vApp = this;
      if(DEBUG) console.log("SHOP CLICK :", idShop);
      vApp.selectIDShop = idShop;
      vApp.showDialogMap = !vApp.showDialogMap;
    },

    loadCurrentShop(idShop) {
      let vApp = this;
      /*             axios({
                  method: "get",
                  url: "http://api.trcgagarinsky.ru/terminal__tmp/index.php/js/get_shop/"+idShop

                })
                  .catch(function(error) {
                    if(DEBUG) console.log("ERROR: ", error);
                  })
                  .then( function(response) {
                  if(DEBUG) console.log("response currentShop = ",response.data );
                  vApp.currentShop = response.data;
                //    vApp.$store.dispatch("updateCategory",response.data);

                    });  */

      vApp.currentShop = vApp.shops.find((fs) => fs.slug == idShop);
      vApp.singleShop = vApp.currentShop;
      if(DEBUG) console.log("vApp.currentShop.nameK :", vApp.currentShop.nameK);
      vApp.currBreadcrumb[2].text = vApp.currentShop.nameK;
      vApp.$store.dispatch("setBreadcrumb", vApp.currBreadcrumb);
      vApp.titleInner = vApp.currentShop.nameK;
      vApp.nameShop = vApp.currentShop.nameK;
    },
    goToPage (url) {
          const vApp = this
          if(DEBUG) console.log('url :>> ', url);


          
      switch (vApp.currBreadcrumb[1].text) {
        case "Магазины":
          vApp.$router
            .push({
              path: '/magaziny/category/'+url,
            })
            .catch(() => {
              if(DEBUG) console.log("error Select Filter route in Services Category")
            })
          break
        case "Кафе и рестораны":

          vApp.$router
            .push({
              path:'/'+ url,
            })
            .catch(() => {
              if(DEBUG) console.log("error Select Filter route in Services Category")
            })
          break
        case "Услуги":
          vApp.$router
            .push({
              path: '/uslugi/category/'+url,
            })
            .catch(() => {
              if(DEBUG) console.log("error Select Filter route in Services Category")
            })
          break
        case "Развлечения":
          vApp.$router
            .push({
              path: '/'+url,
            })
            .catch(() => {
              if(DEBUG) console.log("error Select Filter route in Services Category")
            })
          break

        default:
          break
      }      
    },


    goToSubcategory(sCat){
      const vApp = this
      if(DEBUG) console.log('sCat :>> ', sCat)


    },

  },
created() {
  const vApp = this;
      this.$store.dispatch('fetchData')
      if(DEBUG) console.log("vApp.$route.params.idShop :", vApp.$route.params.idShop);
      vApp.loadCurrentShop(vApp.$route.params.idShop);  
},
  mounted() {
    let vApp = this;
    this.$nextTick(function () {
      if(DEBUG) console.log("mounted SingleShop");


      let scrollEl = document.querySelector("#scrollT");
      scrollEl.scrollTo(0, 0);
    });
  },
  beforeRouteUpdate(to, from, next) {
    let vApp = this;
    // вызывается когда маршрут, что рендерит этот компонент изменился,
    // но этот компонент будет повторно использован в новом маршруте.
    // Например, для маршрута с динамическими параметрами `/foo/:id`, когда мы
    // перемещаемся между `/foo/1` и `/foo/2`, экземпляр того же компонента `Foo`
    // будет использован повторно, и этот хук будет вызван когда это случится.
    // Также имеется доступ в `this` к экземпляру компонента.
    if(DEBUG) console.log("beforeRouteUpdate to :", to.params.idShop);
    if(DEBUG) console.log("vApp.currBreadcrumb :", vApp.currBreadcrumb);
    if(DEBUG) console.log("vApp.currentShop.nameK :", vApp.currentShop.nameK);

    vApp.name = to.params.name;
    next();
    vApp.loadCurrentShop(to.params.idShop);
  },
  /*       beforeRouteEnter(to, from, next) {
        next(vm => {
          // экземпляр компонента доступен как `vm`
          
          if(DEBUG) console.log('Single shop vm :', vm);
        })
      } */
};
</script>
<style  scoped>
.logo-border {
  border: 1px solid #eef;
}
.images-logoNshop {
  display: block;
  position: relative;
}
.logo-shop-card {
  margin-top: -98px;
  /* margin-left: 40px; */
  background-color: #fff;
}
.logo-shop-img {
  width: 120px;
  height: 120px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 90%;
}
.text-catg {
  line-height: 1.5;
}
.text-btn-gotomap {
  font-size: 1rem;
  color: #000;
}
.hover-underline:hover {
  text-decoration: underline;
}
a.phone-link{
  color: #336;
 text-decoration: underline; 
}


a.phone-link:hover{
  text-decoration: unset;
}
</style>